import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { getErrorMessage } from "../../utils/helpers";
import { ERROR, errorNotification } from "../../utils/notifications";
import { readMessageBack } from "../../utils/readMessageBack";
import NotaCreditoBloqueo from "../../types/NotaCreditoBloqueo";
import {
  CancelacionProceso,
  CancelacionProcesoIntento
} from "../../types/CancelacionProceso";

export interface GetNotaCreditoBloqueos {
  notaCreditoBloqueos: NotaCreditoBloqueo[];
  gettingNotaCreditoBloqueos: boolean;
  gettingNotaCreditoBloqueosError: string;
}

export interface PostNotaCreditoBloqueo {
  creatingNotaCreditoBloqueo: boolean;
  creatingNotaCreditoBloqueoError: string;
}

export interface DeleteNotaCreditoBloqueo {
  deletingNotaCreditoBloqueo: boolean;
  deletingNotaCreditoBloqueoError: string;
}

export interface GetCancelacionesProceso {
  cancelacionesProceso: CancelacionProceso[];
  gettingCancelacionesProceso: boolean;
  gettingCancelacionesProcesoError: string;
}

export interface GetCancelacionesIntentos {
  cancelacionesIntentos: CancelacionProcesoIntento[];
  gettingCancelacionesIntentos: boolean;
  gettingCancelacionesIntentosError: string;
}

export interface PostVerificarCancelacion {
  postingVerificarCancelacion: boolean;
  postingVerificarCancelacionError: string;
}

export interface PostConfirmarCancelacion {
  postingConfirmarCancelacion: boolean;
  postingConfirmarCancelacionError: string;
}

export interface PostReenviarSolicitudCancelacion {
  postingReenviarSolicitudCancelacion: boolean;
  postingReenviarSolicitudCancelacionError: string;
}

interface State
  extends GetNotaCreditoBloqueos,
    PostNotaCreditoBloqueo,
    DeleteNotaCreditoBloqueo,
    GetCancelacionesProceso,
    GetCancelacionesIntentos,
    PostVerificarCancelacion,
    PostConfirmarCancelacion,
    PostReenviarSolicitudCancelacion {}

const initialState: State = {
  notaCreditoBloqueos: [],
  gettingNotaCreditoBloqueos: false,
  gettingNotaCreditoBloqueosError: null,

  creatingNotaCreditoBloqueo: false,
  creatingNotaCreditoBloqueoError: null,

  deletingNotaCreditoBloqueo: false,
  deletingNotaCreditoBloqueoError: null,

  cancelacionesProceso: [],
  gettingCancelacionesProceso: false,
  gettingCancelacionesProcesoError: null,

  cancelacionesIntentos: [],
  gettingCancelacionesIntentos: false,
  gettingCancelacionesIntentosError: null,

  postingVerificarCancelacion: false,
  postingVerificarCancelacionError: null,

  postingConfirmarCancelacion: false,
  postingConfirmarCancelacionError: null,

  postingReenviarSolicitudCancelacion: false,
  postingReenviarSolicitudCancelacionError: null
};

export default function notasCreditoReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    // GET_NOTA_CREDITO_BLOQUEADAS
    case `${actionTypes.GET_NOTA_CREDITO_BLOQUEADAS}_PENDING`: {
      return {
        notaCreditoBloqueos: [],
        gettingNotaCreditoBloqueos: true,
        gettingNotaCreditoBloqueosError: null
      };
    }
    case `${actionTypes.GET_NOTA_CREDITO_BLOQUEADAS}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        gettingNotaCreditoBloqueos: false,
        gettingNotaCreditoBloqueosError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_NOTA_CREDITO_BLOQUEADAS}_FULFILLED`: {
      return {
        notaCreditoBloqueos: action.payload.data,
        gettingNotaCreditoBloqueos: false,
        gettingNotaCreditoBloqueosError: null
      };
    }

    // POST_NOTA_CREDITO_BLOQUEADA
    case `${actionTypes.POST_NOTA_CREDITO_BLOQUEADA}_PENDING`: {
      return {
        creatingNotaCreditoBloqueo: true,
        creatingNotaCreditoBloqueoError: null
      };
    }
    case `${actionTypes.POST_NOTA_CREDITO_BLOQUEADA}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        creatingNotaCreditoBloqueo: false,
        creatingNotaCreditoBloqueoError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.POST_NOTA_CREDITO_BLOQUEADA}_FULFILLED`: {
      return {
        creatingNotaCreditoBloqueo: false,
        creatingNotaCreditoBloqueoError: null
      };
    }

    // DELETE_NOTA_CREDITO_BLOQUEADA
    case `${actionTypes.DELETE_NOTA_CREDITO_BLOQUEADA}_PENDING`: {
      return {
        deletingNotaCreditoBloqueo: true,
        deletingNotaCreditoBloqueoError: null
      };
    }
    case `${actionTypes.DELETE_NOTA_CREDITO_BLOQUEADA}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        deletingNotaCreditoBloqueo: false,
        deletingNotaCreditoBloqueoError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.DELETE_NOTA_CREDITO_BLOQUEADA}_FULFILLED`: {
      return {
        deletingNotaCreditoBloqueo: false,
        deletingNotaCreditoBloqueoError: null
      };
    }

    // GET_CANCELACIONES_BY_PERIODO
    case `${actionTypes.GET_CANCELACIONES_BY_PERIODO}_PENDING`: {
      return {
        cancelacionesProceso: [],
        gettingCancelacionesProceso: true,
        gettingCancelacionesProcesoError: null
      };
    }
    case `${actionTypes.GET_CANCELACIONES_BY_PERIODO}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        gettingCancelacionesProceso: false,
        gettingCancelacionesProcesoError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_CANCELACIONES_BY_PERIODO}_FULFILLED`: {
      return {
        cancelacionesProceso: action.payload.data,
        gettingCancelacionesProceso: false,
        gettingCancelacionesProcesoError: null
      };
    }

    // GET_CANCELACIONES_BY_FOLIO
    case `${actionTypes.GET_CANCELACIONES_BY_FOLIO}_PENDING`: {
      return {
        cancelacionesProceso: [],
        gettingCancelacionesProceso: true,
        gettingCancelacionesProcesoError: null
      };
    }
    case `${actionTypes.GET_CANCELACIONES_BY_FOLIO}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        gettingCancelacionesProceso: false,
        gettingCancelacionesProcesoError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_CANCELACIONES_BY_FOLIO}_FULFILLED`: {
      return {
        cancelacionesProceso: action.payload.data,
        gettingCancelacionesProceso: false,
        gettingCancelacionesProcesoError: null
      };
    }

    // GET_CANCELACIONES_INTENTOS_BY_FACTURA
    case `${actionTypes.GET_CANCELACIONES_INTENTOS_BY_FACTURA}_PENDING`: {
      return {
        cancelacionesIntentos: [],
        gettingCancelacionesIntentos: true,
        gettingCancelacionesIntentosError: null
      };
    }
    case `${actionTypes.GET_CANCELACIONES_INTENTOS_BY_FACTURA}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        gettingCancelacionesIntentos: false,
        gettingCancelacionesIntentosError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_CANCELACIONES_INTENTOS_BY_FACTURA}_FULFILLED`: {
      return {
        cancelacionesIntentos: action.payload.data,
        gettingCancelacionesIntentos: false,
        gettingCancelacionesIntentosError: null
      };
    }

    // POST_VERIFICAR_CANCELACION
    case `${actionTypes.POST_VERIFICAR_CANCELACION}_PENDING`: {
      return {
        postingVerificarCancelacion: true,
        postingVerificarCancelacionError: null
      };
    }
    case `${actionTypes.POST_VERIFICAR_CANCELACION}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        postingVerificarCancelacion: false,
        postingVerificarCancelacionError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.POST_VERIFICAR_CANCELACION}_FULFILLED`: {
      return {
        postingVerificarCancelacion: false,
        postingVerificarCancelacionError: null
      };
    }

    // POST_CONFIRMAR_CANCELACION
    case `${actionTypes.POST_CONFIRMAR_CANCELACION}_PENDING`: {
      return {
        postingConfirmarCancelacion: true,
        postingConfirmarCancelacionError: null
      };
    }
    case `${actionTypes.POST_CONFIRMAR_CANCELACION}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        postingConfirmarCancelacion: false,
        postingConfirmarCancelacionError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.POST_CONFIRMAR_CANCELACION}_FULFILLED`: {
      return {
        postingConfirmarCancelacion: false,
        postingConfirmarCancelacionError: null
      };
    }

    // POST_REENVIAR_SOLICITUD_CANCELACION
    case `${actionTypes.POST_REENVIAR_SOLICITUD_CANCELACION}_PENDING`: {
      return {
        postingReenviarSolicitudCancelacion: true,
        postingReenviarSolicitudCancelacionError: null
      };
    }
    case `${actionTypes.POST_REENVIAR_SOLICITUD_CANCELACION}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        postingReenviarSolicitudCancelacion: false,
        postingReenviarSolicitudCancelacionError: getErrorMessage(
          action.payload
        )
      };
    }
    case `${actionTypes.POST_REENVIAR_SOLICITUD_CANCELACION}_FULFILLED`: {
      return {
        postingReenviarSolicitudCancelacion: false,
        postingReenviarSolicitudCancelacionError: null
      };
    }

    default: {
      return state;
    }
  }
}

export { initialState };
